import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { BIG_MARGIN, colorsPalette, LARGE_MARGIN, MIDDLE_MARGIN, SUBMIDDLE_MARGIN } from '../../theme';

const useStyles = (isDark) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        padding: `${BIG_MARGIN}px 0 ${BIG_MARGIN - SUBMIDDLE_MARGIN}px`,
        background: isDark ? colorsPalette.blueDark : colorsPalette.blackSecondary,
        '& .swiperWrapper': {
          paddingTop: SUBMIDDLE_MARGIN,
        },
        [theme.breakpoints.up('md')]: {
          padding: `${LARGE_MARGIN}px 0 ${LARGE_MARGIN - SUBMIDDLE_MARGIN}px`,
        },
      },
      title: {
        textAlign: 'center',
        marginBottom: 0,
      },
      cardsWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        margin: `${MIDDLE_MARGIN}px -12px 0`,
      },
      card: {
        height: 310,
        width: '100%',
        margin: '0 0 24px',
        [theme.breakpoints.up('md')]: {
          height: 350,
          width: 'calc((100% / 4) - 24px)',
          margin: '0 12px 24px',
        },
        [theme.breakpoints.up('lg')]: {
          width: 'calc((100% / 5) - 24px)',
        },
      },
      cardContent: {
        height: '100%',
      },
    }),
  );

export default useStyles;
